import { Component, Input } from "@angular/core";

@Component({
  selector: "app-custom-switch",
  templateUrl: "./custom-switch.component.html",
  styleUrls: ["./custom-switch.component.scss"],
  standalone: true
})
export class CustomSwitchComponent {
  @Input() label: string;
  @Input() check: string;
}
